<template>
  <v-container fluid class="about-container pa-0">
    <!-- 顶部背景横幅 -->
    <div class="banner-section">
      <v-container>
        <div class="text-center">
          <v-avatar size="180" class="mt-10 profile-avatar">
            <v-img src="https://cdn.vuetifyjs.com/images/john.jpg" alt="Aholic"></v-img>
          </v-avatar>
          <h1 class="text-h3 white--text mt-4 font-weight-bold">Aholic</h1>
          <p class="text-h6 white--text mt-2 font-weight-regular">热爱技术，热爱生活</p>
        </div>
      </v-container>
    </div>

    <!-- 主要内容区域 -->
    <v-container class="mt-n10">
      <v-row>
        <!-- 左侧卡片：关于我 -->
        <v-col cols="12" md="4">
          <v-card class="mb-4" elevation="2">
            <v-card-title class="primary white--text">
              <v-icon left color="white">mdi-account-circle</v-icon>
              个人简介
            </v-card-title>
            <v-card-text class="mt-4">
              <div class="text-body-1">
                <p>👋 你好，我是 Aholic</p>
                <p class="mt-2">💻 全栈开发工程师</p>
                <p class="mt-2">🌟 热爱编程，享受创造的过程</p>
                <p class="mt-2">📚 持续学习，不断进步</p>
              </div>
            </v-card-text>
          </v-card>

          <!-- 联系方式卡片 -->
          <v-card elevation="2">
            <v-card-title class="primary white--text">
              <v-icon left color="white">mdi-email</v-icon>
              联系方式
            </v-card-title>
            <v-card-text class="mt-4">
              <v-list>
                <v-list-item>
                  <v-list-item-icon>
                    <v-icon color="primary">mdi-email</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-subtitle>your.email@example.com</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item>
                  <v-list-item-icon>
                    <v-icon color="primary">mdi-github</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-subtitle>github.com/yourusername</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item>
                  <v-list-item-icon>
                    <v-icon color="primary">mdi-wechat</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-subtitle>WeChat: your_wechat</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card-text>
          </v-card>
        </v-col>

        <!-- 右侧卡片：技能和项目展示 -->
        <v-col cols="12" md="8">
          <!-- 技能卡片 -->
          <v-card class="mb-4" elevation="2">
            <v-card-title class="primary white--text">
              <v-icon left color="white">mdi-lightning-bolt</v-icon>
              技能特长
            </v-card-title>
            <v-card-text class="mt-4">
              <v-row>
                <v-col cols="12" sm="6">
                  <div class="skill-category mb-4">
                    <h3 class="text-h6 primary--text mb-2">前端开发</h3>
                    <v-chip-group>
                      <v-chip color="primary" outlined>Vue.js</v-chip>
                      <v-chip color="primary" outlined>React</v-chip>
                      <v-chip color="primary" outlined>JavaScript</v-chip>
                      <v-chip color="primary" outlined>CSS3</v-chip>
                    </v-chip-group>
                  </div>
                </v-col>
                <v-col cols="12" sm="6">
                  <div class="skill-category mb-4">
                    <h3 class="text-h6 primary--text mb-2">后端开发</h3>
                    <v-chip-group>
                      <v-chip color="primary" outlined>Node.js</v-chip>
                      <v-chip color="primary" outlined>Python</v-chip>
                      <v-chip color="primary" outlined>Java</v-chip>
                      <v-chip color="primary" outlined>MySQL</v-chip>
                    </v-chip-group>
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>

          <!-- 项目经历卡片 -->
          <v-card elevation="2">
            <v-card-title class="primary white--text">
              <v-icon left color="white">mdi-briefcase</v-icon>
              项目经历
            </v-card-title>
            <v-card-text class="mt-4">
              <v-timeline dense>
                <v-timeline-item
                  v-for="(project, i) in projects"
                  :key="i"
                  color="primary"
                  small
                >
                  <div class="mb-4">
                    <h3 class="text-h6 primary--text mb-2">{{ project.name }}</h3>
                    <p class="text-body-2 grey--text">{{ project.date }}</p>
                    <p class="text-body-1 mt-2">{{ project.description }}</p>
                  </div>
                </v-timeline-item>
              </v-timeline>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-container>
</template>

<script>
export default {
  name: 'AboutPage',
  data() {
    return {
      projects: [
        {
          name: '个人博客系统',
          date: '2024年3月',
          description: '使用Vue.js和Node.js开发的个人博客系统，支持文章发布、评论等功能。'
        },
        {
          name: '在线商城项目',
          date: '2023年12月',
          description: '基于React和Spring Boot的电商平台，实现了商品管理、订单处理等核心功能。'
        },
        {
          name: '企业管理系统',
          date: '2023年9月',
          description: '为某企业开发的内部管理系统，提供了人事管理、考勤统计等功能。'
        }
      ]
    }
  }
}
</script>

<style scoped>
.about-container {
  background-color: #f5f5f5;
}

.banner-section {
  background: linear-gradient(135deg, var(--v-primary-base) 0%, var(--v-primary-lighten2) 100%);
  min-height: 400px;
  padding-bottom: 100px;
}

.profile-avatar {
  border: 4px solid white;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.skill-category {
  background: #f8f9fa;
  padding: 16px;
  border-radius: 8px;
}

.v-timeline-item__body {
  margin-bottom: 16px;
}

.v-card {
  border-radius: 8px;
  overflow: hidden;
}

.v-card-title {
  padding: 16px;
}

.v-chip {
  margin: 4px;
}
</style> 